
 function RoadmapCard({step, title, text}: {step: string, title: string, text: string}) {
  return (
    <div className="h-[30vh] rounded-lg drop-shadow-lg flex flex-col justify-center gap-y-2 ">
      <div className="mb-2">
        <span className="text-xl font-bold text-black rounded-full bg-white px-2 py-1 roadmap-card-step">Phase {step}</span>
      </div>
        <h1 className="text-3xl font-bold text-slate-100 ">{title}</h1>
        <span className="text-neutral-100 font-semibold text-balance">{text}</span>
    </div>
    
  )
}

export default RoadmapCard
